﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconListCheck } from "@tabler/icons-react";

export const TiposRequisitosHelpText = "* Aquí puede ver la lista de los diversos tipos de requisitos.";
export const TiposRequisitosIcon = IconListCheck;
export class catTiposRequisitos extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposRequisitos";
        this.def.columns.c_category_id.defaultValue = "TiposRequisitos";
        this.Title = "Tipos de Requisitos";
        this.Icon = TiposRequisitosIcon;
        this.HelpText = TiposRequisitosHelpText;
    }
}